import React from "react";
import { Nav, NavItem, NavLink } from "shards-react";

import Notifications from "./Notifications";
import UserActions from "./UserActions";
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { birthdayslogout } from "../../../../../../actions/auth";
import Errors from "../../../../views/Errors";
import Spinner from "../../../../../layout-spinner/Spinner";

function NavbarNav({ auth: { birthdaysloading, birthdaysuser }, birthdayslogout }) {
  
  return ( birthdaysloading ? <Spinner /> : birthdaysloading === false && birthdaysuser !== null ?
    <React.Fragment>
    <Nav navbar className="md-mr-3 ml-auto navItems">
            <NavItem className = "mt-2">
                  {typeof birthdaysuser !== 'undefined' && birthdaysuser !==null && birthdaysuser.workspaceName !== null ? birthdaysuser.workspaceName : console.log('nada')}
            </NavItem>
              <NavItem>
              <NavLink className = "text-center mt-n2 mr-md-2" onClick={birthdayslogout} href='#!'>
              {(
                <div
                  className="d-inline-block item-icon-wrapper"
                  dangerouslySetInnerHTML={{ __html: '<i class="material-icons">logout</i>' }}
                />)}
              {<span>{" Logout"}</span>}
                </NavLink>
            </NavItem>
    {/* <Notifications /> */}
    {/* <UserActions /> */}
  </Nav>
  </React.Fragment> : <Errors />
  )
}


NavbarNav.propTypes = {
  birthdayslogout: PropTypes.func.isRequired,
  birthdaysauth: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth
});

export default connect(
  mapStateToProps,
  { birthdayslogout }
)(NavbarNav);

